export const joinRender = (array, renderFunc, joinString) => (
  array.flatMap((e, i) => ((i > 0) ? [joinString, renderFunc(e)] : [renderFunc(e)]))
);
